import { PlannedRoutesPricesFilter } from '../types';
import { ListItem } from 'shared/types';

interface Filter {
  priceService?: ListItem;
}

export const mappingRoutePriceCriteria = ({
  priceService 
}: Filter): PlannedRoutesPricesFilter => ({
  ...priceService && { serviceCodes: [priceService.key] }
});
